<template>
  <div>
    <Breadcrumbs title="BIS 정산 목록" main="정산"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <h5>BIS 정산 목록 ( 총 : {{ totalCount ? totalCount : 0 }} 개 )</h5>
              <div class="p-1 m-t-5 d-flex align-items-center btnBox" style="border: solid rgba(175, 173, 173, 0.29) 1px">
                <div class="pe-1">
                  <Datepicker week-start="0" :day-class="isWeekendClass" class="datepicker-here datepicker-multi digits b-r-0 mr-1" :multi="true" format="MM-dd-yyyy" v-model="date" range locale="ko">
                  </Datepicker>
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <select v-model="filter1Type" class="form-select btn-square digits">
                    <option value="All">전체</option>
                    <option value="Branch">지점명</option>
                    <option value="Product">상품명</option>
                    <option value="Customer">고객명</option>
                    <option value="CouponNo">쿠폰번호</option>
                    <option value="Provider">업체명</option>
                    <option value="Address">주소</option>
                    <option value="Engineer">기사명</option>
                    <option value="BasicType">기본장착비</option>
                    <option value="OptionType">추가장착비</option>
                    <option value="UinstallType">탈거비</option>
                  </select>
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <input v-model="filter1Val" @input="handleFilter1Val" @keypress.enter="searchSettle(true)" class="form-control btn-square w-100" type="text" placeholder="">
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <select v-model="filter2Type" class="form-select btn-square digits">
                    <option value="All">전체</option>
                    <option value="Branch">지점명</option>
                    <option value="Product">상품명</option>
                    <option value="Customer">고객명</option>
                    <option value="CouponNo">쿠폰번호</option>
                    <option value="Provider">업체명</option>
                    <option value="Address">주소</option>
                    <option value="Engineer">기사명</option>
                    <option value="BasicType">기본장착비</option>
                    <option value="OptionType">추가장착비</option>
                    <option value="UinstallType">탈거비</option>
                  </select>     
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <input v-model="filter2Val" @input="handleFilter2Val" @keypress.enter="searchSettle(true)" class="form-control btn-square w-100" type="text" placeholder="">
                </div>
                <div class="mx-2 d-flex align-items-center">
                  <span>
                    정산구분: 
                  </span>
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <select v-model="queryObj.settleYn" class="form-select btn-square digits">
                    <option>전체</option>
                    <option value="N">미정산</option>
                    <option value="Y">정산</option>
                  </select>     
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <button @click="searchSettle(true)" class="btn btn-square btn-primary w-100" type="button" title="btn btn-outline-light btn-sm">검색</button>
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <button @click="changeSearchSettle('TaxInvoice')" class="btn btn-square btn-outline-light txt-dark w-100" type="button" title="btn btn-outline-light btn-sm">세금계산서</button>
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <button @click="changeSearchSettle('CreditCard')" class="btn btn-square btn-outline-light txt-dark w-100" type="button" title="btn btn-outline-light btn-sm">카드</button>
                </div>
                <div class="pe-1 d-flex justify-content-center">
                  <button @click="excelDownload" class="btn btn-square btn-success w-100" type="button" title="btn btn-outline-light btn-sm" :disabled="isExcelDown">{{ isExcelDown ? '다운로드 중..' : '다운로드' }}</button>
                </div>
              </div>
              <div class="d-flex align-items-center mt-3">
                <div class="d-flex align-items-center me-2">
                  <span style="font-size:16px;">미정산 건수 총 : {{ incompleteCount }} 건</span>
                </div>
                <div class="d-flex align-items-center">
                  <span style="font-size:16px;color:rgb(223, 0, 0);" class="me-1">전체정산처리: </span>
                  <button @click="completeAll" class="btn btn-square btn-primary me-2" type="button" title="btn btn-outline-light btn-sm">적용</button>
                  <span style="font-size:16px;color:rgb(223, 0, 0);" class="me-1">선택정산처리: </span>
                  <button :disabled="!itemsSelected.length" @click="completeAllSelected" class="btn btn-square btn-danger" type="button" title="btn btn-outline-light btn-sm">적용</button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div>
                <div class="d-flex justify-content-between">
                </div>
              </div>
              <div class="table-responsive mt-3">
                <EasyDataTable ref="dataTable" v-model:server-options="serverOptions" v-model:items-selected="itemsSelected" :headers="Headers" :rowsPerPage="10" :items="settleList" hide-footer header-text-direction="center"
                  border-cell body-text-direction="center" empty-message="조회된 데이터가 없습니다">
                  <template #item-productName="{ productName }">
                     <div style="width:100%;text-align:left !important;"><span>{{ productName }}</span></div>
                  </template>                  
                  <template #item-customer="{ customerName, id, orderTypeCode }">
                    <a href="/" style="color:#1071BC" data-bs-toggle="modal" :data-bs-target="`#calInfoDetail${id}`">{{ customerName }}</a>
                    <div class="modal fade" data-bs-keyboard="false" data-bs-backdrop="static" data-bs-focus="false" :id="`calInfoDetail${id}`" tabindex="-1" role="dialog" :aria-labelledby="`calInfoDetail${id}`"
                    aria-hidden="true">
                      <InfoDetailModal :orderId="id" :isRead="true" :searchType="orderTypeCode === '00010' ? 'order' : orderTypeCode === '00011' ? 'claim' : 'as'" />
                    </div>
                  </template>
                  <template #item-customerPhone="{ customerPhoneNo1 }">
                    <span>{{ conversionPhoneNo(customerPhoneNo1) }}</span>
                  </template>
                  <template #item-customerAddr="{address}">
                    <div style="width:100%;text-align:left !important;">
                      <span>{{ address }}</span>
                    </div>
                  </template>
                  <template #item-engineerName="{ engineerId, engineerName }">
                    <span style="color:#1071BC;cursor:pointer;" @click="openEngineerCertPic(engineerId)">{{ engineerName }}</span>
                  </template>                  
                  <template #item-orderType="{orderTypeCode}">
                    <div class="d-flex justify-content-center">
                      <span>{{ orderTypeCode === '00010' ? '주문' : orderTypeCode === '00011' ? '클레임' : 'A/S' }}</span>
                    </div>
                  </template>
                  <template #item-basicPayment="{id, basicPaymentId ,basicPaymentMethod, orderTypeCode }">
                    <a href="/" style="color:#1071BC" data-bs-toggle="modal" :data-bs-target="`#calPayment${id}basic`">{{ basicPaymentMethod }}</a>
                    <div class="modal fade" data-bs-keyboard="false" data-bs-backdrop="static" :id="`calPayment${id}basic`" tabindex="-1" role="dialog" :aria-labelledby="`calPayment${id}basic`"
                      aria-hidden="true">
                      <PaymentTypeModal :orderId="id" :searchType="orderTypeCode === '00010' ? 'order' : orderTypeCode === '00011' ? 'claim' : 'as'" type="basic"/>
                    </div>
                  </template>
                  <template #item-optionPayment="{id, optionPaymentId, optionPaymentMethod, orderTypeCode }">
                    <a href="/" style="color:#1071BC" data-bs-toggle="modal" :data-bs-target="`#calPayment${id}option`">{{ optionPaymentMethod }}</a>
                    <div class="modal fade" data-bs-keyboard="false" data-bs-backdrop="static" :id="`calPayment${id}option`" tabindex="-1" role="dialog" :aria-labelledby="`calPayment${id}option`"
                      aria-hidden="true">
                      <PaymentTypeModal :orderId="id" :searchType="orderTypeCode === '00010' ? 'order' : orderTypeCode === '00011' ? 'claim' : 'as'" type="option"/>
                    </div>
                  </template>
                  <template #item-removalPayment="{id, removalPaymentId, uinstallPaymentMethod, orderTypeCode }">
                    <a href="/" style="color:#1071BC" data-bs-toggle="modal" :data-bs-target="`#calPayment${id}removal`">{{ uinstallPaymentMethod }}</a>
                    <div class="modal fade" data-bs-keyboard="false" data-bs-backdrop="static" :id="`calPayment${id}removal`" tabindex="-1" role="dialog" :aria-labelledby="`calPayment${id}removal`"
                      aria-hidden="true">
                      <PaymentTypeModal :orderId="id" :searchType="orderTypeCode === '00010' ? 'order' : orderTypeCode === '00011' ? 'claim' : 'as'" type="removal"/>
                    </div>
                  </template>
                  <template #item-progress="{ statName, id, orderTypeCode }">
                    <a href="/" style="color:#1071BC" data-bs-toggle="modal" :data-bs-target="`#calProgress${id}`">{{ statName }}</a>
                    <div class="modal fade" data-bs-keyboard="false" data-bs-backdrop="static" :id="`calProgress${id}`" tabindex="-1" role="dialog" :aria-labelledby="`calProgress${id}`"
                      aria-hidden="true">
                      <ProgressModal :orderId="id" :searchType="orderTypeCode === '00010' ? 'order' : orderTypeCode === '00011' ? 'claim' : 'as'"/>
                    </div>
                  </template>
                  <template #item-settlement="{settleYn}">
                    <div class="d-flex row">
                      <div class="d-flex justify-content-center">
                        <span>{{ settleYn === 'Y' ? '정산완료' : '미정산' }}</span>
                      </div>
                      <!-- <div class="d-flex justify-content-center">
                        <span style="font-size:10px;">{{ hcDateTime ? hcDateTime : '' }}</span>
                      </div> -->
                    </div>
                  </template>
                  <template #item-settleComplete="{settleDateTime}">
                    <div class="d-flex row">
                      <div class="d-flex justify-content-center">
                        <span>{{ settleDateTime ? settleDateTime : '-' }}</span>
                      </div>
                      <!-- <div class="d-flex justify-content-center">
                        <span style="font-size:10px;">{{ smsDateTime ? smsDateTime : '' }}</span>
                      </div> -->
                    </div>
                  </template>
                  <template #item-installConfirm="{ id, statName, orderTypeCode }">
                    <!--완료-->
                    <div v-if="statName === '완료'">
                      <a href="/" style="color:#1071BC" data-bs-toggle="modal" :data-bs-target="`#calInstall${id}`">조회</a>
                      <div class="modal fade" data-bs-keyboard="false" data-bs-backdrop="static" :id="`calInstall${id}`" tabindex="-1" role="dialog" :aria-labelledby="`calInstall${id}`"
                        aria-hidden="true">
                        <InstallConfirmModal :orderId="id" :searchType="orderTypeCode === '00010' ? 'order' : orderTypeCode === '00011' ? 'claim' : 'as'"/>
                      </div>
                    </div>
                    <span v-else>미설치</span>
                  </template>
                  <template #item-detailed="{ id }">
                    <router-link :to="{name: 'orderModify', params:{id}, query:{size, pno, saFilter, startDateTime: queryObj.startDateTime, endDateTime: queryObj.endDateTime, filter1: queryObj.filter1, filter2: queryObj.filter2, name: 'calculateBISList'}}" style="color:#1071BC">조회</router-link>
                  </template>
                </EasyDataTable>
                <div class="customize-footer">
                  <div class="customize-rows-per-page mt-1">
                    <select
                      class="select-items"
                      @change="updateRowsPerPageSelect"
                    >
                      <option
                        v-for="item in rowsPerPageOpt"
                        :key="item"
                        :selected="item === rowsPerPageActiveOption"
                        :value="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="customize-index">
                    <nav class="m-b-30" aria-label="">
                      <ul class="pagination justify-content-center pagination-primary">

                        <li class="page-item prev-page" @click="firstPage" :disabled="isFirstPage"><a class="page-link" href="javascript:void(0)">처음</a></li>
                        <li class="page-item" @click="prevPage" :disabled="isFirstPage"><a class="page-link" href="javascript:void(0)">이전</a></li>
                        <li v-for="paginationNumber in pageList"
                          class="page-item customize-button"
                          :class="{ 'active': paginationNumber === pageNo + 1 }"
                          @click="updatePage(paginationNumber)"
                        >
                          <a class="page-link" href="javascript:void(0)">{{ paginationNumber }}</a>
                        </li>
                        <li class="page-item" @click="nextPage" :disabled="isLastPage"><a class="page-link" href="javascript:void(0)">다음</a></li>
                        <li class="page-item next-page" @click="lastPage" :disabled="isLastPage"><a class="page-link" href="javascript:void(0)">끝</a></li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import Swal from 'sweetalert2';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ref, onMounted, computed, watch } from 'vue';
import InfoDetailModal from '@/components/list/InfoDetailModal.vue'
import PaymentTypeModal from '@/components/list/PaymentTypeModal.vue'
import ProgressModal from '@/components/list/ProgressModal.vue'
import InstallConfirmModal from '@/components/list/InstallConfirmModal.vue'
import { RouterLink, useRouter, useRoute } from 'vue-router'
import { useLoginAuth } from '@/stores/LoginAuthStore'
import useSettleManagement from '@/composables/settleManagement'
import useOrderRegistry from '@/composables/registerOrder'
import commonApi from '@/composables/commonApi'
import { settlementHeader } from '@/constants/ListHeader'
const router = useRouter()
const route = useRoute()
const LoginAuthStore = useLoginAuth(router)
const { loadCommonCode, loadResource, picture } = commonApi(LoginAuthStore);
const { settleList, pageInfo, listSettle, completeSettleList, completeSettleAllList, incompleteSettleCount, incompleteCount, settleExcelDownload, settleExcelDownloadSelected } = useSettleManagement(LoginAuthStore);
const { loadEngineer, certPicUri } = useOrderRegistry(LoginAuthStore);
const pageNo = computed(() => pageInfo.value?.pageNo);
const totalCount = computed(() => pageInfo.value?.totalCount);
const totalPages = computed(() => pageInfo.value?.totalPages);
const pageList = ref([])
const filter1Type = ref('All')
const filter2Type = ref('All')
const filter1Val = ref('')
const filter2Val = ref('')
const pno = ref(0)
const size = ref(25);
const pageNum = 10;
const saFilter = ref('None')
const paymentType = ref('Bis')
const queryObj = ref({settleYn: 'N', startDateTime: '', endDateTime: '', filter1: filter1Type.value, filter2: filter2Type.value, saFilter: saFilter.value, rrp: size.value, pno: pno.value, paymentType: paymentType.value});

/*
// 날짜 범위 : 최근 31일
// 30일전 ~ 오늘
const defaultStartDate = new Date();
defaultStartDate.setDate((new Date()).getDate() - 30); // 별도로 setDate() 를 해야 형식이 유지됨

const defaultEndDate = new Date();

const date = ref([defaultStartDate, defaultEndDate]);
*/

const date = ref([]);

const progressListRef = ref([])
const isSearchClick = ref(false);
const isExcelDown = ref(false);
const currentPageListStart = () => {
  return Math.floor(pno.value / pageNum) * pageNum + 1
}
const paging = async () => {
  //보여지는 페이지 리셋
  pageList.value = [];

  //현재페이지 기준으로 페이징 숫자 넣기
  let pageListStart = await currentPageListStart()
  for (let i = 1; i < pageNum + 1; i++) {  
    if (totalPages.value >= pageListStart){
      pageList.value.push(pageListStart)
      pageListStart ++;
    }
  }
}

const searchSettle = async (click) => {
  if (click) isSearchClick.value = true;
  if (isSearchClick.value) {
    pno.value = 0
    queryObj.value.filter1 = filter1Val.value ? `${filter1Type.value}:${filter1Val.value}` : 'All';
    queryObj.value.filter2 = filter2Val.value ? `${filter2Type.value}:${filter2Val.value}` : 'All';
    saFilter.value = 'None';
    queryObj.value.startDateTime = date.value ? dateFormatStringForApi(date?.value[0]) : null
    queryObj.value.endDateTime = date.value ? dateFormatStringForApi(date?.value[1]) : null
  }

  // 페이지 초기 진입시 이 케이스
  queryObj.value.rrp = size.value
  queryObj.value.pno = pno.value
  queryObj.value.saFilter = saFilter.value

  queryObj.value.startDateTime = date.value ? dateFormatStringForApi(date?.value[0]) : null
  queryObj.value.endDateTime = date.value ? dateFormatStringForApi(date?.value[1]) : null

  await listSettle(queryObj.value)
  isSearchClick.value = false;
  setTimeout(async () => {
    await paging()
  }, 1000);
}

onMounted(async () => {
  // const endDate = new Date();
  // const startDate = new Date(new Date().setDate(endDate.getDate() - 7));
  // date.value = [startDate, endDate];
  // 진행상황
  loadCommonCode('00004').then(res => res.json()).then(res => progressListRef.value = res.payload);
  // loadSelectBranchList();
  await searchSettle();
  await incompleteSettleCount(queryObj.value, "Bis");
  // getTodayReceiptCount();
})
const itemsSelected = ref([]);

const completeAllSelected = async () => {
  const confirmSettle = await new Swal({
    title: '정산처리 하시겠습니까?',
    showCancelButton: true,
    showClass: {
      backdrop: 'swal2-noanimation', // disable backdrop animation
      popup: '',                     // disable popup animation
      icon: ''                       // disable icon animation
    },
    hideClass: {
      popup: '',                     // disable popup fade-out animation
    },
  });
  if (confirmSettle.isConfirmed) {
    const selectedIdList = itemsSelected.value.map(item => item.id);
    if(selectedIdList.length) {
      await completeSettleList(selectedIdList);
      setTimeout(() => {
        searchSettle();
      }, 500);
    }
    itemsSelected.value = [];
  }
}

const excelDownload = async () => {
  if (itemsSelected.value.length === 0 
    && !(filter1Val.value || filter2Val.value 
    || (date?.value !== null && (date?.value[0] || date?.value[1])))) {
    return alert('엑셀 다운로드 시 조건(검색어를 포함한 검색, 체크박스 또는 기간)을 선택해 주세요.');
  }  new Swal({
    title: "엑셀 다운로드 하시겠습니까?",
    showClass: {
      backdrop: 'swal2-noanimation', // disable backdrop animation
      popup: '',                     // disable popup animation
      icon: ''                       // disable icon animation
    },
    hideClass: {
      popup: '',                     // disable popup fade-out animation
    },
    showConfirmButton: true, // "확인" 버튼 표시 안 함
    showCancelButton: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      isExcelDown.value = true;
      if (itemsSelected.value.length) {
        const selectedIdList = itemsSelected.value.map(item => item.id);
        await settleExcelDownloadSelected(selectedIdList, isExcelDown);
      } else {
        queryObj.value.filter1 = filter1Val.value ? `${filter1Type.value}:${filter1Val.value}` : 'All';
        queryObj.value.filter2 = filter2Val.value ? `${filter2Type.value}:${filter2Val.value}` : 'All';
        saFilter.value = 'None';
        queryObj.value.startDateTime = date.value ? dateFormatStringForApi(date?.value[0]) : null
        queryObj.value.endDateTime = date.value ? dateFormatStringForApi(date?.value[1]) : null
        await settleExcelDownload(queryObj.value, isExcelDown)
      }
    }
  })
}

const completeAll = async () => {
  const confirmSettle = await new Swal({
    title: '현재 검색된 모든 주문 건에 대해 정산처리 하시겠습니까?',
    showCancelButton: true,
    showClass: {
      backdrop: 'swal2-noanimation', // disable backdrop animation
      popup: '',                     // disable popup animation
      icon: ''                       // disable icon animation
    },
    hideClass: {
      popup: '',                     // disable popup fade-out animation
    },
  });
  if (confirmSettle.isConfirmed) {
    await completeSettleAllList();
    setTimeout(() => {
      searchSettle();
    }, 500);
  }
}

const changeSearchSettle = async (type) => {
  saFilter.value = type;
  searchSettle();
}

// $ref dataTable
const dataTable = ref();

// index related
const currentPageFirstIndex = computed(() => dataTable.value?.currentPageFirstIndex);
const currentPageLastIndex = computed(() => dataTable.value?.currentPageLastIndex);
const clientItemsLength = computed(() => dataTable.value?.clientItemsLength);

const isFirstPage = computed(() => dataTable.value?.isFirstPage);
const isLastPage = computed(() => dataTable.value?.isLastPage);

const updatePage = async (paginationNumber) => {
  pno.value = paginationNumber - 1;
  await searchSettle();
};
const lastPage = () => {
  updatePage(totalPages.value);
};
const firstPage = () => {
  updatePage(1);
};
const prevPage = () => {
  if (pno.value >= 1) updatePage(pno.value);
};
const nextPage = () => {
  if (pno.value + 2 <= totalPages.value) updatePage(pno.value + 2);
};

// rows per page related
const rowsPerPageOpt = [10, 25, 50, 100];
// const rowsPerPageOptions = computed(() => dataTable.value?.rowsPerPageOptions);
const rowsPerPageActiveOption = computed(() => dataTable.value?.rowsPerPageActiveOption);
const updateRowsPerPageSelect = async (e) => {
  size.value = Number(e.target.value);
  dataTable.value.updateRowsPerPageActiveOption(Number(e.target.value));
  await updatePage(1);
  await searchSettle()
};

const pic = ref('')
const openEngineerCertPic = async (engId) => {
  await loadEngineer(engId)
}
const openPicture = (url) => {
  new Swal({
    imageUrl: url,
    showClass: {
      backdrop: 'swal2-noanimation', // disable backdrop animation
      popup: '',                     // disable popup animation
      icon: ''                       // disable icon animation
    },
    hideClass: {
      popup: '',                     // disable popup fade-out animation
    },
    showConfirmButton: false, // "확인" 버튼 표시 안 함
    showCancelButton: true,
  }).then(() => {
    certPicUri.value = '';
  });
}

const leftPad = (val) => {
  if (val >= 10) return val;
  return `0${val}`;
}
const dateFormatStringForApi = (date) => {
  if (date) {
    const year = date.getFullYear()
    const month = leftPad(date.getMonth() + 1)
    const day = leftPad(date.getDate())
  
    return `${[month, day, year].join('/')}`
  }
}

const conversionPhoneNo = (phoneNo) => {
  const phone = phoneNo.replace(/-/g, "");
  if (phone.length === 12) {
    return phone.replace(/^(\d{4})(\d{4})(\d{4})$/, `$1-$2-$3`);
  } else {
    return phone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }
}

const handleFilter1Val = (e) => {
  if (filter1Type.value === 'BasicType' || filter1Type.value === 'OptionType' || filter1Type.value === 'UinstallType') {
    filter1Val.value = e.target.value.replace(/[^0-9]/g, '');
  } else filter1Val.value = e.target.value
}
const handleFilter2Val = (e) => {
  if (filter2Type.value === 'BasicType' || filter2Type.value === 'OptionType' || filter2Type.value === 'UinstallType') {
    filter2Val.value = e.target.value.replace(/[^0-9]/g, '');
  } else filter2Val.value = e.target.value
}

watch(filter1Type, (newVal, oldVal) => {
  if (newVal) filter1Val.value = '';
})
watch(filter2Type, (newVal, oldVal) => {
  if (newVal) filter2Val.value = '';
})

watch(certPicUri, async (newVal, oldVal) => {
  if (certPicUri.value) await loadResource(certPicUri.value)
})
watch(picture, (newVal, oldVal) => {
  picture.value.blob().then(blob => {
    pic.value = URL.createObjectURL(blob)
    return openPicture(pic.value)
  })
})

const serverOptions = ref({
  page: Number(pno.value),
  rowsPerPage: Number(size.value),
})

const Headers = ref(settlementHeader);
const isWeekendClass = (date) => {
  if (date.getDay() === 0) return 'sunColor'
  if (date.getDay() === 6) return 'satColor'
  return
}
</script>